export default __webpack_public_path__ + "static/logo_leathersta-07aa2629b5e73ff87c3a1c8e25d23366.png";